import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

const SIDENAV_COLLAPSED_KEY = 'sidenavCollapsed';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  private _quickpanelOpenSubject = new BehaviorSubject<boolean>(false);
  quickpanelOpen$ = this._quickpanelOpenSubject.asObservable();

  private _sidenavOpenSubject = new BehaviorSubject<boolean>(false);
  sidenavOpen$ = this._sidenavOpenSubject.asObservable();

  private _sidenavCollapsedSubject = new BehaviorSubject<boolean>(LayoutService.readSidenavCollapsed());
  sidenavCollapsed$ = this._sidenavCollapsedSubject.asObservable();

  private _sidenavCollapsedOpenSubject = new BehaviorSubject<boolean>(false);
  sidenavCollapsedOpen$ = this._sidenavCollapsedOpenSubject.asObservable();

  private _configpanelOpenSubject = new BehaviorSubject<boolean>(false);
  configpanelOpen$ = this._configpanelOpenSubject.asObservable();

  private _searchOpen = new BehaviorSubject<boolean>(false);
  searchOpen$ = this._searchOpen.asObservable();

  private _pageNavigatorSubject = new BehaviorSubject<Array<{ label: string, route?: string, icon?: string, prefixIcon?: string }>>(null);
  pageNavigator$ = this._pageNavigatorSubject.asObservable();

  private _projectDetailsSubject = new BehaviorSubject<{ project_name?: string }>(null);
  projectDetails$ = this._projectDetailsSubject.asObservable();

  constructor(private router: Router) { }

  openQuickpanel() {
    this._quickpanelOpenSubject.next(true);
  }

  closeQuickpanel() {
    this._quickpanelOpenSubject.next(false);
  }

  openSidenav() {
    this._sidenavOpenSubject.next(true);
  }

  closeSidenav() {
    this._sidenavOpenSubject.next(false);
  }

  collapseSidenav() {
    this.setSidenavCollapsed(true);
  }

  expandSidenav() {
    this.setSidenavCollapsed(false);
  }

  toggleSidenavCollapsed() {
    this.setSidenavCollapsed(!this._sidenavCollapsedSubject.getValue());
  }

  /** Each user's own choice, kept across reloads and sign-ins on this browser. */
  private setSidenavCollapsed(collapsed: boolean) {
    this._sidenavCollapsedSubject.next(collapsed);
    try {
      localStorage.setItem(SIDENAV_COLLAPSED_KEY, String(collapsed));
    } catch (e) {
      // Storage can be unavailable (private mode); the choice then lasts the session.
    }
  }

  /** Collapsed to icons unless the user has expanded it before. */
  private static readSidenavCollapsed(): boolean {
    try {
      return localStorage.getItem(SIDENAV_COLLAPSED_KEY) !== 'false';
    } catch (e) {
      return true;
    }
  }

  collapseOpenSidenav() {
    this._sidenavCollapsedOpenSubject.next(true);
  }

  collapseCloseSidenav() {
    this._sidenavCollapsedOpenSubject.next(false);
  }

  openConfigpanel() {
    this._configpanelOpenSubject.next(true);
  }

  closeConfigpanel() {
    this._configpanelOpenSubject.next(false);
  }

  openSearch() {
    this._searchOpen.next(true);
  }

  closeSearch() {
    this._searchOpen.next(false);
  }

  setPageNavigator(navigator: Array<{ label: string, route?: string, icon?: string, prefixIcon?: string }>) {
    this._pageNavigatorSubject.next(navigator);
  }

  clearPageNavigator() {
    this._pageNavigatorSubject.next(null);
  }

  setProjectDetails(projectDetails: { project_name?: string }) {
    this._projectDetailsSubject.next(projectDetails);
  }

  clearProjectDetails() {
    this._projectDetailsSubject.next(null);
  }

  enableRTL() {
    this.router.navigate([], {
      queryParams: {
        rtl: 'true'
      }
    }).then(() => {
      if (window) {
        window.location.reload();
      }
    });
  }

  disableRTL() {
    this.router.navigate([], {
      queryParams: {
        rtl: 'false'
      }
    }).then(() => {
      if (window) {
        window.location.reload();
      }
    });
  }
}
